import { injectable } from 'inversify';
import * as React from 'react';
import { SupportedLanguage } from '../generated/types';
import { NodeEnv } from '../nodeEnv';

export type TranslateFn = (key: string, ...args: any[]) => string;

@injectable()
export class TranslationService {
    constructor(
        public language: SupportedLanguage,
        private translations: { [key: string]: string }
    ) {}

    translate(key: string, ...args: any[]): string {
        if (process.env.NODE_ENV === NodeEnv.Test && !process.env.JEST_WORKER_ID) {
            return `${key} - ${JSON.stringify(args)}`;
        } else {
            let translation = this.translations[key] || key;
            const pluralTranslation = this.translations[`${key}_plural`];

            if (pluralTranslation && typeof args[0] === 'number' && args[0] > 1) {
                translation = pluralTranslation;
            }

            if (Array.isArray(args) && args.length > 0) {
                translation = args.reduce(
                    (currentTranslation, arg, index) =>
                        currentTranslation.replaceAll(`{${index + 1}}`, arg),
                    translation
                );
            }

            return translation;
        }
    }

    *interpolateWithComponents(
        translated: string,
        ...components: React.ReactNode[]
    ): Generator<React.ReactNode, void, void> {
        let times = 0;
        for (const [i, part] of translated.split(/{\d+}/).entries()) {
            if (times > 0) {
                yield <React.Fragment key={times}>{components[i - 1]}</React.Fragment>;
            }
            times++;
            yield part;
        }
    }

    formatListValues(values: string[], type: Intl.ListFormatType = 'disjunction'): string {
        return new Intl.ListFormat(this.language.toLowerCase(), {
            style: 'long',
            type
        }).format(values);
    }
}
